<template>
	<div v-if="$route.name!='operate'" class="operate">
		<div class="header">
			<el-menu router :default-active="$route.name" mode="horizontal">
				<el-menu-item index="operate_config" :route="{name:'operate_config'}">基本设置</el-menu-item>
				<el-menu-item index="operate_charging" :route="{name:'operate_charging'}">计费设置</el-menu-item>
				<el-menu-item index="operate_area" :route="{name:'operate_area'}">返程设置</el-menu-item>
				<el-menu-item index="operate_admin" :route="{name:'operate_admin'}">管理员</el-menu-item>
			</el-menu>
		</div>
		<router-view ref="operateCallback"></router-view>
	</div>
</template>

<script>
	export default {
		created() {
			this.resetRoute();
		},
		methods: {
			resetRoute(){
				const that = this;
				if (that.$route.name == 'operate') {
					that.$router.push({
						name: 'operate_config'
					});
				}
			}
		},
		watch: {
			$route: {
				handler: 'resetRoute'
			}
		}
	}
</script>
